// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageGradient_container__1oXLl"};